import React, { useEffect } from 'react'
import { Table, Image, Upload, message, Switch } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { assetsListModel } from '../assetsListModel'
import { IAssetsListDetail } from '../assetsListService'
import { useDictModel } from '@/views/base/dict/dictModel'
import { MaterialCodeModal } from './materialModel'
import { UserModal } from './userModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from '@/utils/constants'
import { CloseOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { UploadChangeParam } from 'antd/lib/upload'
import { UploadFile } from 'antd/lib/upload/interface'
import { globalPrompt } from '@/components/message'
import { debounce } from 'lodash'
import { assetsEntryService } from '../../assetsEntry/assetsEntryService'
import { assetsListService } from '../assetsListService'

export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg, materialCodeRow, materialCodeVisible, uesrVisible, selectedIdKeys, setSelectedIdKeys, setUesrVisible, setMaterialCodeVisible, loadData, setSelectedRowKeys, setMaterialCodeRow } = assetsListModel()
    const { getTreeNodeName, getSelectedDictOne } = useDictModel(() => [])
    useEffect(() => {
        loadData()
    }, [])
    const detialEdit = (value) => {
        setMaterialCodeRow(value)
        setMaterialCodeVisible(true)
    }
    const detialUser = (value) => {
        setMaterialCodeRow(value)
        setUesrVisible(true)
    }
    const deleteImg = (value) => {
        globalPrompt("modal", {
            title: '物资图片删除',
            type: 'warning',
            text: `您是否删除${value.materialCode}物资图片？`,
            okText: '确认',
            onOk: debounce(async () => {
                try {
                    let result = await assetsEntryService.deleteImg({
                        code: value.materialCode,
                        md5: "",
                        fileName: ""
                    });
                    result && message.success('物资图片删除成功！');
                    loadData()
                } catch (error) {
                    message.error('物资图片删除失败！')
                }
            }, 500),
            cancelText: '取消',
            onCancel: () => { },
        })
    }
    const onPreview = async (file, res) => {
        try {
            if (file.status === 'done') {
                if (file.response.retCode == 0) {
                    const data = {
                        name: file.name,
                        size: file.size,
                        type: file.type,
                        uid: file.response.retData,
                    }
                    let result = await assetsEntryService.deleteImg({
                        code: res.materialCode,
                        md5: data.uid,
                        fileName: data.name
                    });
                    result && message.success('物资图片添加成功！');
                    loadData()
                } else {
                    message.error('图片上传失败，请重新上传!')
                }
            }

        } catch (error) {
            message.error('物资图片添加失败！')
        }

    }
    const handleDepartmentStatusChange = async (checked: boolean, record: IAssetsListDetail) => {
        try {
            const result = await assetsListService.updateDepartmentStatus(record.id)
            if (result) {
                loadData()
                message.success('更新成功！')
            }
        } catch (error) {
            message.error('更新失败！')
        }
    }
    const columns: ColumnsType<IAssetsListDetail> = [
        {
            title: '序号',
            width: 60,
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '物资图片',
            width: 140,
            align: "center",
            fixed: "left",
            render: (text, records) =>
            (records.md5 ? <>
                <Image src={getBaseImgLookUrl(records.md5)} style={{ maxWidth: '50px', maxHeight: '70px' }} />
                <CloseOutlined onClick={() => deleteImg(records)} style={{ color: 'red', fontSize: '14px', position: 'absolute', right: '10px', cursor: 'pointer' }} /></>
                : <Upload
                    name="file"
                    action={getBaseImgUploadUrl()}
                    data={getBaseUploadData()}
                    // listType="picture"
                    onChange={(info: UploadChangeParam<UploadFile<any>>) => onPreview(info.file, records)}
                    showUploadList={false}
                    beforeUpload={(file) => {
                        let fileEnd: string = file.name.substring(file.name.lastIndexOf("."));
                        let filetypes: string[] = [".jpg", ".png", ".jpeg", "svg", ".gif"];
                        let isType = filetypes?.includes(fileEnd);
                        // if (!isType) {
                        //     message.error('不支持该格式的上传,当前仅支持.jpg", ".png", ".jpeg", "svg", ".gif"类型文件');
                        // }
                        const isLt20M = file.size / 1024 / 1024 < 20
                        if (!isLt20M) {
                            message.error('上传到文件不能超过20M')
                        }
                        // return isType && isLt20M
                        return isLt20M
                    }}
                > <PlusCircleOutlined style={{ color: 'blue', fontSize: '22px', cursor: 'pointer' }} />
                </Upload>
            )
        },
        {
            title: '物资编码',
            width: 160,
            dataIndex: 'materialCode',
            fixed: 'left',
            render: (t, r) => (
                <span style={{ color: '#4165E3', cursor: 'pointer' }} onClick={() => detialEdit(r)} > {t} </span>)
        },
        {
            title: '物资名称',
            width: 160,
            fixed: 'left',
            dataIndex: 'materialName',
        },
        // {
        //     title: '仓库',
        //     width: 190,
        //     dataIndex: 'warehouseName',
        // },
        {
            title: '所属仓库',
            width: 100,
            dataIndex: 'warehouseName',
        },
        {
            title: '货位',
            width: 120,
            dataIndex: 'shelfCode',
        },
        // {
        //     title: '物资类型',
        //     width: 120,
        //     dataIndex: 'typeName',  
        // },
        // {
        //     title: '库存数量',
        //     width: 100,
        //     dataIndex: 'inventoryNum',
        // },
        // {
        //     title: '占用数量',
        //     width: 100,
        //     dataIndex: 'inventoryOccupied',
        // },
        // {
        //     title: '可用数量',
        //     width: 100,
        //     dataIndex: 'availableStock',
        // },
        // {
        //     title: '进货价',
        //     width: 100,
        //     dataIndex: 'price',
        // },
        // {
        //     title: '入库数量',
        //     width: 100,
        //     dataIndex: 'num',
        // },
        // {
        //     title: '入库金额',
        //     width: 100,
        //     dataIndex: 'amount',
        // },
        // {
        //     title: '供应商名称',
        //     width: 100,
        //     dataIndex: 'supplierName',
        // },
        // {
        //     title: '采购单号',
        //     width: 100,
        //     dataIndex: 'code',
        // },
        // {
        //     title: '入库时间',
        //     width: 160,
        //     dataIndex: 'createTime',
        // },

        // {
        //     title: '当前存放地点',
        //     width: 120,
        //     dataIndex: 'deposit',
        // },
        {
            title: '申请部门',
            width: 200,
            dataIndex: 'departmentName',
        },
        {
            title: '所属部门',
            width: 200,
            dataIndex: 'department',
        },
        {
            title: '现使用人',
            width: 120,
            dataIndex: 'user',
            render: (t, r) => (
                <span style={{ color: '#4165E3', cursor: 'pointer' }} onClick={() => detialUser(r)} > {t} </span>)
        },
        {
            title: '资产状态',
            width: 80,
            dataIndex: 'status',
            render: (text: string) => getSelectedDictOne(DictCodeEnmu.ASSETS_STATUS).find((item) => item.value === text)?.label ?? '',
        },
        {
            title: '是否部门在用',
            width: 120,
            align: 'center',
            dataIndex: 'departmentStatus',
            render: (text: any | null, record) => {
                if (text === null) {
                    return null
                }
                return (
                    <Switch
                        checked={text === 1}
                        onChange={(checked) => handleDepartmentStatusChange(checked, record)}
                        checkedChildren="在用"
                        unCheckedChildren="闲置"
                    />
                )
            }
        },
        // {
        //     title: '条形码',
        //     width: 110,
        //     dataIndex: 'barCode',
        // },
        {
            title: '占用单号',
            width: 100,
            dataIndex: 'occupyCode',
        },
    ]

    //点击行选高亮
    const onRow = (record: IAssetsListDetail) => {
        let findObj = selectedRowKeys.find((item) => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter((item) => item.id !== record.id)
            let newSelectedIdKeys = selectedIdKeys.filter((item) => item !== record.id)
            setSelectedRowKeys(newSelectedRowKeys)
            setSelectedIdKeys(newSelectedIdKeys)
        } else {
            setSelectedRowKeys((origin) => [...origin, record])
            setSelectedIdKeys((origin) => [...origin, record.id])
        }
    }

    return (
        <>
            <Table
                rowKey={(record) => record.id}
                rowSelection={{
                    //全部选中时 (存row[])
                    onSelectAll: (selected, selectedRows, changeRows) => {
                        selected
                            ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
                            : setSelectedRowKeys((origin) => {
                                let changeRowId = changeRows.map((item) => item.id)
                                return origin.filter((item) => changeRowId.indexOf(item.id) < 0)
                            })
                    },
                    onSelect: (record, selected, selectedRows) => onRow(record),
                    selectedRowKeys: selectedRowKeys.map((item) => item.id),
                }}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ['bottomCenter'],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                    showSizeChanger: true
                }}
                bordered
                onRow={(record) => ({
                    onClick: () => onRow(record),
                    onContextMenu: (e) => {
                        e.preventDefault()
                        setSelectedRowKeys([record])
                        setSelectedIdKeys([record.id])
                    },
                })}
                scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
            />
            <MaterialCodeModal />
            <UserModal />
        </>
    )
}
